import { render, staticRenderFns } from "./ExitButton.vue?vue&type=template&id=1a1f62e2&scoped=true&"
import script from "./ExitButton.vue?vue&type=script&lang=js&"
export * from "./ExitButton.vue?vue&type=script&lang=js&"
import style0 from "./ExitButton.vue?vue&type=style&index=0&id=1a1f62e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1f62e2",
  null
  
)

export default component.exports